import React from "react";
import "./Body.css";

import Adv1 from "../Advertisements/Adv1";
import Slider from "./Slider";
import Footer from "../Footer/Footer";

function Body() {
  return (
    <div>
      <div className="Home">
        <div className="home__container home__image">
          <Slider />
        </div>

        <div className="home__row">
          <Adv1
            id="12321341"
            title="All the Light We Cannot See: A Novel"
            price={12.99}
            rating={5}
            image="https://images.squarespace-cdn.com/content/v1/605b7322b806fb292a9defce/1617816625655-PUCD8T87L4YO2KZGMQPU/all-the-light-we-cannot-see_Anthony_Doerr.jpg"
          />
          <Adv1
            id="12321341"
            title="SAMSUNG Galaxy Watch 5 44mm Bluetooth Smartwatch w/Body, Health, Fitness and Sleep Tracker, Improved"
            price={179.99}
            rating={5}
            image="https://images-na.ssl-images-amazon.com/images/I/61s1Na3W61L._AC_UL450_SR450,320_.jpg"
          />
          <Adv1
            id="12321341"
            title="Fire 7 tablet, 7 display, 16 GB, (2019 release), Twilight Blue"
            price={59.99}
            rating={5}
            image="https://m.media-amazon.com/images/I/71POuqajw1L._AC_SL1500_.jpg"
          />
          <Adv1
            id="12321341"
            title="KitchenAid Digital Countertop Oven with Air Fry - KCO124BM"
            price={219.99}
            rating={4}
            image="https://m.media-amazon.com/images/I/81cO+n1wP9L._AC_SL1500_.jpg"
          />
        </div>
        {/*  */}
        <div className="home__row">
          <Adv1
            id="12321341"
            title="SAMSUNG 85-Inch Class QLED Q60A Series - 4K UHD Dual LED Quantum Smart TV"
            price={1666.94}
            rating={5}
            image="https://m.media-amazon.com/images/I/51WJPUmlXAL._AC_SL1000_.jpg"
          />
          <Adv1
            id="12321341"
            title="Lenovo IdeaPad 1 14 Laptop, 14.0 HD Display, Intel Celeron N4020, 4GB RAM, 64GB Storage, Intel UHD Graphics 600"
            price={200.99}
            rating={4}
            image="https://m.media-amazon.com/images/I/71IVTMa5JQL._AC_SL1500_.jpg"
          />
          <Adv1
            id="12321341"
            title="Coach Women's Mollie Bucket Bag 22 Crossbody Shoulder"
            price={154.42}
            rating={5}
            image="https://m.media-amazon.com/images/I/51OtOYWL3iL._AC_UX395_.jpg"
          />
        </div>
        {/*  */}
        <div className="home__row">
          <Adv1
            id="12321341"
            title="Fire TV Stick Lite, free and live TV, Alexa Voice Remote Lite, smart home controls, HD streaming"
            price={29.99}
            rating={5}
            image="https://m.media-amazon.com/images/I/41DTzx56EWL._AC_SL1000_.jpg"
          />
          <Adv1
            id="12321341"
            title="Rubbermaid Commercial Products-1902465 , Executive Quick Carts Mobile/Travel Office Cart for Housekeeper, Sales Rep, Medical Professionals"
            price={407.99}
            rating={5}
            image="https://m.media-amazon.com/images/I/71-R0cuWxQL._SL1500_.jpg"
          />
        </div>
        {/* ///// */}
        <div className="home__row">
          <Adv1
            id="12321341"
            title="Acer Chromebook Spin 311 Convertible Laptop | Intel Celeron N4000 | 11.6 HD Touch Corning Gorilla Glass Display | 4GB LPDDR4 | 64GB eMMC | Intel 802.11ac Gigabit WiFi 5 | Chrome OS | CP311-2H-C7QD"
            price={185.99}
            rating={4}
            image="https://m.media-amazon.com/images/I/71c5W9NxN5L._AC_SL1500_.jpg"
          />
          <Adv1
            id="12321341"
            title="4K Video Camera Camcorder 48MP UHD WiFi IR Night Vision Vlogging Camera for YouTube 16X Digital Zoom Touch Screen Camera Recorder with Microphone, Handheld Stabilizer, Lens Hood, Remote,2 Batteries"
            price={149.99}
            rating={5}
            image="https://m.media-amazon.com/images/I/81LTw7v1I9L._AC_SL1500_.jpg"
          />
          <Adv1
            id="12321341"
            title="GoPro HERO10 Black - Waterproof Action Camera with Front LCD and Touch Rear Screens, 5.3K60 Ultra HD Video, 23MP Photos, 1080p Live Streaming, Webcam, Stabilization"
            price={388.0}
            rating={5}
            image="https://m.media-amazon.com/images/I/7153iHpXMQL._AC_SL1500_.jpg"
          />
          <Adv1
            id="12321341"
            title="LINCO Lincostore Photo Video Studio Light Kit AM169 - Including 3 Color Backdrops (Black/White/Green) Background Screen"
            price={174.99}
            rating={4}
            image="https://m.media-amazon.com/images/I/71cqrETKK6L._AC_SL1500_.jpg"
          />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Body;
